import React from 'react';
import { offer } from '../data/offer';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-court" data-id="element-135" data-mp="2236cg4d6qnxj">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-136" data-mp="22124nbc614rz">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-shuttle bg-white/10 text-shuttle" data-id="element-137" data-mp="1x54op64te0fq">
          <span className="font-display text-4xl font-extrabold leading-none" data-id="element-138" data-mp="14g6482d7ym79">{offer.guaranteeDays}</span>
          <span className="font-display text-xs font-bold uppercase tracking-widest" data-id="element-139" data-mp="1j4tw9ynuwdsg">Days</span>
        </div>
        <p className="mt-6 text-[11px] font-bold uppercase tracking-[1.6px] text-shuttle" data-id="element-140" data-mp="1ecsoaoxq1988">
          Zero risk
        </p>
        <h2 id="guarantee-heading" className="mt-3 font-display font-bold text-white text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-141" data-mp="qmevuxb858d4">
          Open everything. Run a session from it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/85" data-id="element-142" data-mp="tymiwb3d3t0a">
          Read the volumes, print the sheets, take one session on court. If
          Badminton Class Ready doesn&apos;t change how you plan and run your
          sessions, email us within {offer.guaranteeDays} days and you get every
          cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-143" data-mp="61p7ylhjvre5">
          {chips.map(chip => <li key={chip} className="rounded-full border border-white/30 px-4 py-2 text-[13px] text-white/90" data-id="element-144" data-mp="b0s41gfjyn9z">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}